import { useEffect } from 'react';
import { useChatStore } from '../chat/chatStore.js';

/**
 * Mirrors what is waiting into the document title: "(3) Orbit Sync".
 *
 * The fallback signal, and the only one that always works. System notifications
 * need a secure context and an explicit grant; a title badge needs neither, so
 * on the plain-HTTP deployment it is what a user in another tab actually sees.
 * A shared file arrives as a message, so it is counted like one.
 */

const BASE_TITLE = 'Orbit Sync';

export function useUnreadTitle(): void {
  const unread = useChatStore((state) => state.unread);

  useEffect(() => {
    const unreadCount = Object.values(unread).reduce((sum, count) => sum + count, 0);
    document.title = title(unreadCount);

    // Signing out unmounts the shell; the tab must not keep claiming unreads.
    return () => {
      document.title = BASE_TITLE;
    };
  }, [unread]);
}

function title(total: number): string {
  return total > 0 ? `(${total > 99 ? '99+' : total}) ${BASE_TITLE}` : BASE_TITLE;
}
